import React from "react";
import { useNavigate } from "react-router-dom";
import { Create } from "adminApi/PositionsApi/Positions";
import { validateForm } from "utils/validation";
import Spinner from "Common/Globle/Spinner";
import AddPositionsForm from "./components/AddPositionsForm";
import fields from "../json/Positions.json";
import useFormChange from "Hooks/useFormChange";
import useFormSubmit from "Hooks/useFormSubmit";
import { PositionRules } from "validation/ValidationRules";


const AddPositions = () => {
    const navigate = useNavigate();
    const { formdata } = fields;

    // Initialize form values from JSON fields
    const initialValues = formdata.reduce((acc, field) => ({ ...acc, [field.name]: "" }), {});

    const { values, errors, handleChange, setErrors } = useFormChange(
        initialValues,
        PositionRules
    );

    // Form submit
    const { loading: loadingSubmit, handleSubmit } = useFormSubmit(
        async (formValues) => {
            return await Create({ data: formValues });
        },
        (vals) => {
            const err = validateForm(vals, PositionRules)
            setErrors(err);
            return err;
        },
        () => navigate(-1),
        "Position added successfully"
    );

    return (
        <>
            {loadingSubmit && <Spinner isSpinner={true} />}
            <AddPositionsForm
                values={values}
                errors={errors}
                handleChange={handleChange}
                handleSubmit={(e) => handleSubmit(e, values)}
                loading={loadingSubmit}
            />
        </>
    );
};

export default AddPositions;
